<div class="card tree-card">
  <div
    class="card-header tree-header"
    [class.is-root-drop-target]="isRootDropTarget"
    (dragover)="onRootDragOver($event)"
    (dragleave)="onRootDragLeave($event)"
    (drop)="onRootDrop($event)"
  >
    <span class="tree-title">Объекты</span>

    <div class="tree-actions">
      <button
        type="button"
        class="icon-btn root-drop-btn"
        *ngIf="touchDraggingNode"
        (click)="onTouchDropToRoot()"
        aria-label="Вынести в корень"
        title="Вынести в корень"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M12 19V5" />
          <path d="M5 12l7-7 7 7" />
        </svg>
      </button>

      <button
        type="button"
        class="icon-btn"
        *ngIf="isEditMode"
        (click)="addRootNode()"
        aria-label="Добавить корневой объект"
        title="Добавить корневой объект"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="12" y1="5" x2="12" y2="19" />
          <line x1="5" y1="12" x2="19" y2="12" />
        </svg>
      </button>

      <button
        type="button"
        class="icon-btn"
        [class.active]="isEditMode"
        (click)="toggleEditMode()"
        aria-label="Режим редактирования"
        [attr.aria-pressed]="isEditMode"
        title="Режим редактирования"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
        </svg>
      </button>
    </div>
  </div>

  <div class="card-body tree-body">
    <div *ngIf="isLoading" class="loading-state">
      <div class="spinner"></div>
      <span>Загрузка структуры...</span>
    </div>

    <div *ngIf="!isLoading && treeNodes.length === 0" class="empty-state">
      Объекты не найдены
    </div>

    <ng-template #treeNodeTemplate let-nodes="nodes">
      <ul class="tree-list">
        <li *ngFor="let node of nodes; trackBy: trackByNodeId" class="tree-item">
          <div
            class="tree-node-content"
            [class.is-parent]="node.children.length > 0"
            [class.is-leaf]="node.children.length === 0"
            [class.edit-mode]="isEditMode"
            [class.is-selected]="isSelected(node)"
            [class.is-drop-target]="isDropTarget(node)"
            [class.is-dragging]="isDragging(node)"
            [class.drag-over-top]="
              dragTargetNode?.id === node.id && dragPosition === 'top'
            "
            [class.drag-over-bottom]="
              dragTargetNode?.id === node.id && dragPosition === 'bottom'
            "
            [class.drag-over-center]="
              dragTargetNode?.id === node.id && dragPosition === 'center'
            "
            [class.drag-over-root]="
              dragTargetNode?.id === node.id && dragPosition === 'root'
            "
            [attr.draggable]="isEditMode && canEdit && isDesktop ? true : null"
            [attr.data-node-id]="node.id"
            (dragstart)="onDragStart(node, $event)"
            (dragover)="onDragOver(node, $event)"
            (dragleave)="onDragLeave(node, $event)"
            (drop)="onDrop(node, $event)"
            (click)="handleNodeClick(node, $event)"
            (touchstart)="onTouchStart(node, $event)"
            (touchend)="onTouchEnd()"
            (touchmove)="onTouchMove($event)"
            (contextmenu)="onContextMenu($event)"
          >
            <span
              class="node-icon"
              [class.clickable]="node.children.length > 0"
              (click)="onToggleClick(node, $event)"
              aria-hidden="true"
            >
              <svg
                *ngIf="node.children.length > 0 && !node.expanded"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="9 18 15 12 9 6" />
              </svg>

              <svg
                *ngIf="node.children.length > 0 && node.expanded"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="6 9 12 15 18 9" />
              </svg>

              <svg
                *ngIf="node.children.length === 0"
                class="leaf-icon"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                <line x1="9" y1="3" x2="9" y2="21" />
              </svg>
            </span>

            <span class="node-name" (click)="onNameClick(node, $event)">
              {{ node.name }}
            </span>

            <div class="node-actions" *ngIf="isEditMode">
              <button
                type="button"
                class="action-btn add-btn"
                (click)="$event.stopPropagation(); addChildNode(node, $event)"
                aria-label="Добавить вложенный объект"
                title="Добавить вложенный объект"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <line x1="12" y1="5" x2="12" y2="19" />
                  <line x1="5" y1="12" x2="19" y2="12" />
                </svg>
              </button>

              <button
                type="button"
                class="action-btn edit-btn"
                (click)="$event.stopPropagation(); editNode(node, $event)"
                aria-label="Редактировать"
                title="Редактировать"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M12 20h9" />
                  <path
                    d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"
                  />
                </svg>
              </button>

              <button
                type="button"
                class="action-btn delete-btn"
                (click)="$event.stopPropagation(); deleteNode(node, $event)"
                aria-label="Удалить"
                title="Удалить"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <polyline points="3 6 5 6 21 6" />
                  <path
                    d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
                  />
                </svg>
              </button>
            </div>

            <div
              class="drag-handle"
              *ngIf="isEditMode && isDesktop"
              aria-hidden="true"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <circle cx="9" cy="12" r="1" />
                <circle cx="9" cy="5" r="1" />
                <circle cx="9" cy="19" r="1" />
                <circle cx="15" cy="12" r="1" />
                <circle cx="15" cy="5" r="1" />
                <circle cx="15" cy="19" r="1" />
              </svg>
            </div>
          </div>

          <div
            class="tree-children"
            *ngIf="node.expanded && node.children.length > 0"
          >
            <ng-container
              *ngTemplateOutlet="
                treeNodeTemplate;
                context: { nodes: node.children }
              "
            ></ng-container>
          </div>
        </li>
      </ul>
    </ng-template>

    <ng-container *ngIf="!isLoading && treeNodes.length > 0">
      <ng-container
        *ngTemplateOutlet="treeNodeTemplate; context: { nodes: treeNodes }"
      ></ng-container>
    </ng-container>
  </div>
</div>
